import { App } from "vue";
import helper from "./helper";

export default (app: App): void => {
  app.use(helper);
};
